import React from "react"
import { useTranslation } from "react-i18next"

import { useModal, useBikeStore } from "hooks"
import { normalizeBoolean, getProtectedEmail } from "utils/functions"
import { 
    REQUEST_CANCEL,
    BACK_PROPERTY_TRANSFER_REQUEST,
    BUY_PROPERTY_TRANSFER_REQUEST
 } from "utils/constants"

export const RequestModal = ({ propertyTransferRequestContext, modalType, callbackAndSend }) => {
    const { 
        currentBike: bike,
        isSeller
     } = useBikeStore()
    const { hideModal } = useModal()
    const { t } = useTranslation()

    const validateAndSend = (response) => {
        hideModal()
        callbackAndSend(response)
    }

    const isACancellationModal = modalType === REQUEST_CANCEL
    const isBackToStoreTransferRequest = propertyTransferRequestContext === BACK_PROPERTY_TRANSFER_REQUEST
    const isBuyTransferRequest = propertyTransferRequestContext === BUY_PROPERTY_TRANSFER_REQUEST

    const bikeOwnerMail = isSeller ? bike.bikeOwner.mail : getProtectedEmail(bike.bikeOwner.mail)

    return (
        <div className="p-12">
            <h2 className="c-h2 text-primary text-xl font-bold text-center mt-7 mb-12">
                {`
                    ${isACancellationModal ? t("global.cancel") : t("global.confirm")} 
                    ${isBackToStoreTransferRequest ? t("back_in_store.modal_title", { ns: "bike" }) : t("buy_bike.modal_title", { ns: "bike" })}
                `}
            </h2>

            {isBuyTransferRequest && !isACancellationModal && 
                <p className="mb-7">{t("buy_bike.modal_description", { ns: "bike" })} {bikeOwnerMail}</p>
            }

            <p className="font-bold text-s">
                <strong>{bike?.bikeCode || bike?.code}</strong><br />
                {t(bike?.bikeType)} &ndash; {bike?.bikeBrand} &ndash; {bike?.bikeModel} &ndash; {bike?.bikeColor} <br/>
                {normalizeBoolean(bike?.isVAE) ? t("type_electric", { ns: "bike" }) : t("type_mecanical", { ns: "bike" })}
            </p>

            <div className="flex justify-between flex-col md:flex-row-reverse mt-7">
                <button
                    type="button"
                    className="c-btn c-btn--primary px-7 mb-5 lg:m-0"
                    onClick={validateAndSend}
                >
                    {isACancellationModal
                        ? t("global.yes")
                        : t("global.send")
                    }
                </button>

                <button
                    type="button"
                    className="c-btn c-btn--white-bordered px-7 mb-5 lg:m-0"
                    onClick={hideModal}
                >
                    {isACancellationModal
                        ? t("global.no")
                        : t("global.cancel")
                    }
                </button>
            </div>
        </div>
    )
}